import React from "react";

const TopBar = ({ imageId, text }) => (
  <div className="top-bar bg-nave" id={imageId}>
    <h1 className="top-bar-page-title text-white text-bold xl-txt">{text}</h1>
  </div>
);

export default TopBar;
